module.exports = "/_next/static/images/video_id_7077787598084902190-339b40c98dde61eba7d5696b230c357f.jpg";